<script setup>
import Map from './Map.vue';
import Search from './Search.vue';
import List from './List.vue';
</script>

<template>
    <Suspense>
        <div class="row">
            <div class="small-4">
                <Search/>
                <div class="row store-list-results">
                    <List class="small-4 large-6"/>
                    <Map class="small-4 large-6"/>
                </div>
            </div>
        </div>
    </Suspense>
</template>
